import { ProductXeroLedgerAccountMapping } from 'Products/types'

// CLEARING is a global-only account and is never offered as a product override,
// so it is excluded from the product-level type.
type MappableLedgerAccount = Exclude<
  ProductXeroLedgerAccountMapping['mappableLedgerAccount'],
  'CLEARING'
>

export const XERO_MAPPING_LABELS: Record<MappableLedgerAccount, string> = {
  DEFERRED_REVENUE: 'Deferred revenue Xero account',
  RECOGNIZED_REVENUE: 'Recognized revenue Xero account',
  UNBILLED_REVENUE: 'Unbilled revenue Xero account'
}

export const XERO_MAPPING_HELPER_TEXT: Record<MappableLedgerAccount, string> = {
  DEFERRED_REVENUE:
    'Override the default Xero account used for deferred revenue on this product',
  RECOGNIZED_REVENUE:
    'Override the default Xero account used for recognized revenue on this product',
  UNBILLED_REVENUE:
    'Override the default Xero account used for unbilled revenue on this product'
}

export const XERO_MAPPING_SETTINGS_ROUTE = '/settings/revenue-recognition'

export const formatXeroMappingOption = (code: string, name: string): string =>
  `${name} (${code})`
